<template>
  <div class="modal-container">
    <div class="modal-popup" v-if="practice">

      <div class="close-container">
        <button class="btn-close" @click="onPopupClosed" style="background-image:url(/app/themes/leightons/images/close-nav.svg)"> </button>
      </div>

        <section v-if="(step == 'preform')">
            <h3>No Appointments Available</h3>
            <p>Sorry, there are currently no available appointments at <strong>{{ practice.post_title }}</strong> in <strong>{{ getCurrentMonth }}</strong>. You can check nearby practices or look at other dates to find a suitable alternative. You can also request an appointment and our Dedicated Patient Support team will be in touch to find a suitable appointment for you.</p>
            <div class="submit">
                <button class="btn" @click="(step = 'form')">Request an appointment</button>
            </div>
        </section>

        <section v-if="(step == 'form')">
            <div class="title-container">
                <h2>Request an appointment</h2>
            </div>
            <form action="">
                <div class="form-field" :class="{bad: error_message_fname}">
                    <label for="">First name*</label>
                    <input type="text"  v-model="customer.firstname">
                    <p class="error" v-if="error_message_fname !=''">{{error_message_fname}}</p>
                </div>
                <div :class="{bad: error_message_lname != ''}">
                    <label for="">Last name*</label>
                    <input type="text"  v-model="customer.lastname">
                    <p class="error" v-if="error_message_lname != ''">{{error_message_lname}}</p>
                </div>

                <div :class="{bad: error_message_email}">
                    <p><label for="">Email*</label></p>
                    <input type="email"  v-model="customer.email">
                    <p class="error" v-if="error_message_email != ''">{{error_message_email}}</p>
                </div>

                <div :class="{bad: error_message_phone}">
                    <p><label for="">Phone number*</label></p>
                    <input type="tel"  v-model="customer.phone">
                    <p class="error" v-if="error_message_phone != ''">{{error_message_phone}}</p>
                </div>

                <div>
                    <p><label for="">Preferred call back time</label></p>
                    <p>Any time Mon-Fri, 09:00-17:30</p>
                    <input type="text"  v-model="customer.preferred_time">
                </div>

                <div>
                    <p><label for="">Leave a message</label></p>
                    <textarea  v-model="customer.message" rows="10"></textarea>
                </div>

                <div class="privacy">
                    <h3>Your Privacy</h3>
                    <label for=""><input type="checkbox"  v-model="customer.privacy"><div>*I agree to the handling of my personal information in<br/> accordance with Leightons Opticians & Hearing Care <a :href="(privacyURL)" target="_blank">privacy policy</a>.</div></label>
                </div>

                <div>
                    <label style="position: absolute;top: 0;left: 0;z-index: -1;width: 0;height: 0;opacity: 0;">
                        <span>No spam</span>
                        <input v-model="hs_value" autocomplete="off" tabindex="-1" type="text" />
                    </label>
                </div>

                <div class="message">
                    <p class="bad" v-if="error_message != ''">{{error_message}}</p>
                </div>

                <div class="submit">
                    <button @click.prevent="onFormSubmit" :disabled="!customer.privacy || isSendingData" class="btn">Request an appointment</button>
                </div>

                <template v-if="checkFormFields"></template>
            </form>
        </section>
        <section v-if="(step == 'postform')" class="postform">
            <div class="title-container">
                <h2>Thank you for your request</h2>
            </div>
            <p>We will contact you to confirm your appointment request by the end of the next working day. If your request is urgent, please call us on 0800 52 00 546. Your details won't be passed on or used for marketing purposes.</p>
            <button @click.prevent="onGoHome" class="btn">Home</button>
        </section>
    </div>
  </div>
</template>

<script>
import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
export default ({
    components: {VueHcaptcha},
    emits:["onclose"],
    props: [
        "practice"
    ],
    watch: {
        practice() {
            this.step = "preform";
            this.resetEverything();
        }
    },

    data() {
        return {
            step: "preform",//preform, form, postform
            customer: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                preferred_time: '',
                message: '',
                privacy: false,//false
            },
            isSendingData: false,
            error_message: '',

            error_message_email: '',
            error_message_fname: '',
            error_message_lname: '',
            error_message_phone: '',

            is_submit_at_least_once: false,
            //hcaptcha_sitekey: '',
            //error_message_hcaptcha: '',
            //hcaptcha_verified: false,//false
            hs_value: '',

            closebtn: require('@/assets/close-nav.svg')
        }
    },
    created() {
        this.currentURL = location.host;
        this.homeURL = location.protocol + "//" + location.host.replace('booking.', window.domainPrefix ? window.domainPrefix : '');
        this.privacyURL = this.homeURL + '/privacy-policy/';
        this.termsURL = this.homeURL + '/terms-and-conditions/';
        //this.hcaptcha_sitekey = window.wpHcaptcha.sitekey;
        this.MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    },
    computed: {
        hcaptcha_verified() {
            return this.hs_value === '';
        },
        getCurrentMonth() {
            const now = new Date();
            return `${this.MONTHS[now.getMonth()]} ${now.getFullYear()}`;
        },
        checkFormFields() {
            if (!this.is_submit_at_least_once) {
                return false;
            }
            return this.isFormValid();
        },
    },
    methods: {
        resetEverything() {
            this.customer = {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                preferred_time: '',
                message: '',
                privacy: false,//false
            };
            this.isSendingData = false;
            this.error_message = '';

            this.error_message_email = '';
            this.error_message_fname = '';
            this.error_message_lname = '';
            this.error_message_phone = '';

            this.is_submit_at_least_once = false;
            this.error_message_hcaptcha = '';
            this.captcha_verified = false;
        },
        onPopupClosed() {
            this.$emit("onclose");
        },
        onGoHome() {
            window.location.href = this.homeURL;
        },
        isFormValid () {
            // validation stuff
            this.validate_form_email();
            this.validate_form_name_phone();
            if (this.customer.firstname != "" && this.customer.lastname != "" &&
                    this.customer.email != "" && this.customer.phone != "" &&
                    this.customer.privacy == true &&
                    this.hcaptcha_verified) {
                return this.validateFormData();
            }
            return false;
        },
        validate_form_email() {
            this.error_message_email = "";
            this.customer.email = this.customer.email.trim();
            if (this.customer.email != "") {
                if (!this.validEmail(this.customer.email)) {
                this.error_message_email = 'Email is invalid';
                }
            } else {
                this.error_message_email = "Please fill out this field.";
            }
        },
        validate_form_name_phone() {
            this.error_message_fname = "";
            this.customer.firstname = this.customer.firstname.trim();
            if (this.customer.firstname === "") {
                this.error_message_fname = "Please fill out this field.";
            }

            this.error_message_lname = "";
            this.customer.lastname = this.customer.lastname.trim();
            if (this.customer.lastname === "") {
                this.error_message_lname = "Please fill out this field.";
            }

            this.error_message_phone = "";
            if (this.customer.phone === "") {
                this.error_message_phone = "Please fill out this field.";
            }

            this.error_message_hcaptcha = "";
            if (!this.hcaptcha_verified) {
                this.error_message_hcaptcha = "hCaptcha is not verified yet.";
            }
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateFormData() {
            if (
                this.error_message_email !== "" ||
                this.error_message_fname !== "" ||
                this.error_message_lname !== "" ||
                this.error_message_phone !== "" ||
                this.error_message_hcaptcha !== ""
                ) {
                return false;
            }
            this.error_message = "";
            return true;
        },
        onFormSubmit() {
            this.error_message = "";
            this.is_submit_at_least_once = true;
            if (!this.isFormValid()) {
                if (this.hcaptcha_verified) {
                    this.error_message = "One or more fields have an error. Please check and try again.";
                } else {
                    this.error_message = "Looks like you are a bot. Stops the proccess.";
                }
                return;
            }
            const form_data = {
                location_email: "appointments@thcp.co.uk", // encodeURIComponent(this.practice.email),
                firstname: encodeURIComponent(this.customer.firstname),
                lastname: encodeURIComponent(this.customer.lastname),
                email: encodeURIComponent(this.customer.email),
                phone: encodeURIComponent(this.customer.phone),
                preferred_time: encodeURIComponent(this.customer.preferred_time),
                message: this.customer.message ? encodeURIComponent(this.customer.message) : '',
            };

            this.isSendingData = true;
            const api = window.wpAjax.ajaxUrl + "?action=book_message_notification";
            const thisView = this;
            this.axios.post(api, "form_data=" + JSON.stringify(form_data))
                .then((response) => {
                    this.error_message = '';
                    if (response.data.success == true) {
                        thisView.step = "postform";
                    } else {
                        this.error_message = response.data.data.message;
                        this.isSendingData = false;
                    }
                }).catch((error) => {
                    this.error_message = error;
                    this.isSendingData = false;
                });

        }
    }
})

</script>

<style scoped>
    .modal-container {
      @apply fixed left-0 top-0 w-full h-full m-0 p-0 overflow-y-auto bg-black bg-opacity-70 z-40;
    }
    .modal-popup {
      @apply relative w-full sm:w-[720px] p-10 rounded bg-white mt-28 mx-auto;
    }

    .close-container {
      @apply absolute top-5 right-5 w-[35px] h-[35px] z-50 cursor-pointer;
    }

    .btn-close {
      @apply absolute top-0 left-0 w-[35px] h-[35px] bg-no-repeat bg-contain;
      background-size: 35px 35px;
    }

    section {
        @apply w-full sm:w-[630px] mx-auto pb-[70px] sm:pb-[130px] pt-[45px] px-[30px] sm:px-0;

        .title-container {
            @apply text-center border-b border-navy pb-[30px] mb-[30px];

            h2 {
            @apply text-[25px] sm:text-[30px] tracking-wider leading-tight font-brandon-black text-grey-darker uppercase mb-[10px];
            }

            p {
            @apply tracking-wide text-[20px] text-grey-darker;
            }
        }

        form {

            /* error message text */
            .error {
            @apply text-error font-bold mt-1.5;
            }

            .error.hcapt {
            @apply mt-[-25px];
            }

            /* error block at bottom */
            p.bad {
            @apply text-error font-bold rounded-md border-error border-2 mt-2.5 p-10 bg-white;
            }

            label {
            @apply font-avenir-medium;
            }

            div {
            @apply mb-[30px];
            }

            h3 {
            @apply text-[18px] text-[#103C62] uppercase tracking-wider mb-[20px] sm:mb-[10px] font-bold;
            }

            p label {
            @apply text-[18px] text-[#103C62];
            }

            p {
            @apply text-[#446481];
            }

            p.last {
            @apply mt-[15px];
            }

            input[type="text"] {
            @apply w-full p-[10px] mt-[10px] rounded-md border border-[#62829B];
            }

            input[type="email"] {
            @apply w-full p-[10px] mt-[10px] rounded-md border border-[#62829B];
            }

            input[type="tel"] {
            @apply w-full p-[10px] mt-[10px] rounded-md border border-[#62829B];
            }

            textarea {
            @apply w-full h-[190px] p-[10px] mt-[10px] rounded-md border border-[#62829B] resize-none;
            }

            input[type="number"] {
            @apply p-[10px] mr-[30px] mt-[10px] rounded-md border border-[#62829B];
            }

            input[type="checkbox"] {
            @apply mr-[15px] border-[#62829B] border-[1px] w-[30px] h-[30px] rounded-md;
            }

            input[type=checkbox]:checked {
            @apply accent-pink;
            }

            /* input errors. Note: important this comes after the other input declarations */
            .bad input, .bad select, .bad textarea {
            @apply outline outline-error border-0;
            }

            .news {

            span {
                @apply my-[20px] grid grid-cols-1 sm:grid-cols-3;
            }

            label {
                @apply mb-[15px] sm:m-0 flex text-[#446481] leading-7 justify-start;
            }

            label:nth-of-type(2) {
                @apply sm:justify-center;
            }

            label:nth-of-type(3) {
                @apply sm:justify-end;
            }
            }

            .privacy {

            a {
                @apply underline;
            }

            label {
                @apply my-[20px] flex text-[#446481] leading-normal;

                input {
                @apply shrink-0;
                }
            }

            br {
                @apply hidden sm:block
            }
            }
        }

        &.postform{
            @apply text-center;

            .btn {
                @apply mt-4;
            }
        }

        .submit {
            @apply text-center mt-[30px] mb-0 pt-[40px] border-t border-navy border-opacity-20;

            button {
            @apply sm:w-auto w-full sm:px-[80px];
            }
        }
        }
</style>
